<template>

<div class="select" :class="{'is-flag': flag, 'is-active': is.active}">

	<div class="select-value" :class="{'is-null': this.value === null, 'is-selected': this.value !== null}" v-on:click="onValueClick"><span>{{ selected }}</span></div>

	<div class="select-options" v-if="is.active">

		<div class="select-options-item" v-for="option in input.options" :key="option.id" v-on:click="onOptionClick($event, option.value)"><span>{{ option.text }}</span></div>

	</div>

</div>

</template>

<script>

export default {

	props: ['input', 'flag'],

	data: function() {

		return {
			is: {
				active: false
			}
		}

	},

	computed: {

		value: function() {

			return this.$store.getters['session/values'][this.input.variable]

		},

		selected: function() {

			if (this.value === null) return 'Please select...'

			var match = this.$_.findWhere(this.input.options, {
				value: this.value
			})

			return match ? match.text : 'Please select...'

		}

	},

	created: function() {

		if (this.value !== null && !this.$_.findWhere(this.input.options, {value: this.value})) {

			this.$store.dispatch('set', {
				input: this.input.id,
				variable: this.input.variable,
				value: null
			})

		}

	},

	methods: {

		onValueClick: function() {

			this.is.active = !this.is.active

		},

		onOptionClick: function(e, value) {

			e.stopPropagation()

			this.$store.dispatch('set', {
				input: this.input.id,
				variable: this.input.variable, 
				value: value
			})

			this.is.active = false

		}

	}

}

</script>

<style scoped>

.select {
	width: 310px;
}

.is-mobile .select {
	width: 100%;
}

.select-value {
	width: 100%;
	padding: 0px 20px;
	height: 48px;
	display: flex;
	align-items: center;
	color: #343434;
	font-size: 18px;
	border-radius: 24px;
	border: 2px solid var(--primary-color);
	font-weight: 700;
	transition: all 300ms ease-in-out;
	cursor: pointer;
}

.select-value span {
	display: block;
	line-height: 20px;
	max-height: 40px;
	overflow: hidden;
}

.supplementary-body .select-value {
	font-size: 16px!important;
}

.is-aiding .select-value {
	border-color: var(--aid-color);
}

.is-mobile .select-value {
	font-size: 14px;
	height: 36px;
	border-radius: 16px;
	line-height: 32px;
	padding: 0px 10px;
}

.select.is-active .select-value {
	border-radius: 24px 24px 0px 0px;
}

.is-mobile .select.is-active .select-value {
	border-radius: 16px 16px 0px 0px;
}

.select-value.is-selected {
	background-color: #343434;
	border-color: #343434;
	color: #fff;
}

.is-dark .select-value.is-selected {
	background-color: #343434;
	border-color: var(--primary-color);
	color: #fff;
}

.select-value.is-null {
	font-weight: 100;
	font-style: italic;
	color: #ccc;
	text-transform: lowercase;
}

.select-value:not(.is-selected):hover {
	background-color: var(--primary-color);
	color: #fff;
}

.is-aiding .select-value:not(.is-selected):hover {
	background-color: var(--aid-color);
}

.select-options {
	background-color: #fff;
	border: 2px solid var(--primary-color);
	border-radius: 0px 0px 24px 24px;
	border-top-width: 0px;
	overflow: hidden;
	z-index: 10;
}

.is-aiding .select-options {
	border-color: var(--aid-color);
}

.is-mobile .select-options {
	border-radius: 0px 0px 16px 16px;
}

.select-options-item {
	font-size: 18px;
	color: #343434;
	padding: 10px 20px;
	cursor: pointer;
	font-weight: 300;
}

.is-mobile .select-options-item {
	font-size: 14px;
	padding: 10px;
}

.select-options-item:nth-child(even) {
	background-color: rgba(0, 0, 0, 0.03);
}

.select-options-item:hover,
.select-options-item:nth-child(even):hover {
	background-color: var(--primary-color);
	color: #fff;
	font-weight: 700;
}

.is-aiding .select-options-item:hover,
.is-aiding .select-options-item:nth-child(even):hover {
	background-color: var(--aid-color);
}

</style>